import React from 'react';
// styles
import styles from './styles.module.scss';

const TermsAndConditions = () => {
  return (
    <div className={styles.termsAndConditions}>
      By signing up, I agree To Zuddl &nbsp;
      <a
        href="https://www.zuddl.com/privacy-policy"
        target="_blank"
        className={styles.redirectLink}
      >
        <i>Privacy Policy</i>
      </a>
      ,&nbsp;
      <a
        href="https://www.zuddl.com/terms-of-use"
        target="_blank"
        className={styles.redirectLink}
      >
        <i>Terms of Use</i>
      </a>
      &nbsp; and &nbsp;
      <a
        href="https://www.zuddl.com/terms-of-service"
        target="_blank"
        className={styles.redirectLink}
      >
        <i>Terms of Service</i>
      </a>
    </div>
  );
};

export default TermsAndConditions;
